import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '@/config/api.config';

export const proDashboardService = {
  async getStats() {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.PRO_DASHBOARD.SUMMARY}`,
      );
      return response.data;
    } catch (error) {
      console.error('getStats service error:', error);
      throw error;
    }
  },

  async getSurveyEvolution() {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.PRO_DASHBOARD.MONTHLY_SURVEYS}`,
      );
      const data = response.data || [];

      // Si pas de données, retourner des valeurs par défaut
      if (!data.length) {
        const defaultMonths = [
          'Jan',
          'Fév',
          'Mar',
          'Avr',
          'Mai',
          'Jui',
          'Jul',
          'Aoû',
          'Sep',
          'Oct',
          'Nov',
          'Déc',
        ];
        return {
          total: 0,
          complete: 0,
          draft: 0,
          monthlyData: {
            labels: defaultMonths,
            complete: new Array(12).fill(0),
            draft: new Array(12).fill(0),
          },
        };
      }

      // Transformer les données pour le format attendu par le frontend
      const labels = data.map((point) => {
        const [year, month] = point.month.split('-');
        const date = new Date(year, month - 1);
        return date.toLocaleDateString('fr-FR', { month: 'short' });
      });

      return {
        total: data.reduce((sum, point) => sum + (point.count || 0), 0),
        complete: data.reduce((sum, point) => sum + (point.completed || 0), 0),
        draft: data.reduce((sum, point) => sum + (point.draft || 0), 0),
        monthlyData: {
          labels,
          complete: data.map((point) => point.completed || 0),
          draft: data.map((point) => point.draft || 0),
        },
      };
    } catch (error) {
      console.error('getSurveyEvolution service error:', error);
      throw error;
    }
  },

  async getCompaniesBySector() {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.PRO_DASHBOARD.COMPANY_SECTORS}`,
      );
      return response.data;
    } catch (error) {
      console.error('getCompaniesBySector service error:', error);
      throw error;
    }
  },
};

export default proDashboardService;
